import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import '@refinitiv-ui/elements/button';
import '../components/login-frame.js';
import '../components/heimdall-loader.js';
import '../components/heimdall-error.js';
import { createTeamsLoginStart$ } from '../login-teams.js';
import '../theme.js';

@customElement('heimdall-teams')
export class HeimdallTeams extends LitElement {
  @state()
  _error: unknown = null;

  firstUpdated() {
    createTeamsLoginStart$().subscribe({
      error: (error) => {
        this._error = error;
      },
    });
  }

  render() {
    return html`<login-frame> ${this.getFrameContent()} </login-frame>`;
  }

  getFrameContent() {
    if (this._error) {
      return html`<heimdall-error .error=${this._error}></heimdall-error>`;
    }
    return html`<heimdall-loader />`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'heimdall-teams': HeimdallTeams;
  }
}
